export const DISMISS_JOIN_MODAL_STORAGE_KEY = 'luxLoyalty.dismissJoinModalWithExpiry'
export const LOYALTY_DISMISS_POINTS_DEDUCTION_MODAL_STORAGE_KEY = 'luxLoyalty.dismissPointsDeductionModal'

/**
 * @dev points deduction will affect accruals where the booking date was before the
 * LUX_LOYALTY_POINTS_DEDUCTION_DATE from lib-lux-loyalty and the accrual happened
 * after 27th June 2025 AEST
 * @todo move to lib-lux-loyalty
 */
export const LOYALTY_ACCRUAL_DEDUCTION_CUT_OFF_DATE = '2025-06-26T14:00:00Z'

/**
 * @dev the welcome points of 660 points given to new members on joining has expired
 * We don't have identifiable info to determine which activity is the welcome points
 * We manually expire the points on 29th and 30th September 2025 AEST so use this date to identify the activity
 * @todo move to loyalty service or lib-lux-loyalty
 */
export const LOYALTY_WELCOME_POINT_EXPIRY_DATE_1 = '2025-09-28T14:00:00Z'
export const LOYALTY_WELCOME_POINT_EXPIRY_DATE_2 = '2025-09-29T14:00:00Z'
export const LOYALTY_WELCOME_POINT_EXPIRY_DATE_3 = '2025-10-06T13:00:00Z'

/**
 * Some benefits we want to display in more detail in these regions such as monetary value for
 * travelshoot_credit and tour_exp_credit, etc.
 */
export const LOYALTY_LEAD_REGIONS = ['AU', 'NZ', 'SG', 'GB', 'US'] as const
